module.exports = __webpack_public_path__ + "hero-next-992-75a236d2ab9afdd9693cc5eed3252af8.bundle.webp";